/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PriceMatchInput = {|
  comment?: ?string,
  email: string,
  link: string,
  name: string,
  phone: string,
  postcode?: ?string,
  productId: string,
|};
export type PriceMatchMutationVariables = {|
  input: PriceMatchInput
|};
export type PriceMatchMutationResponse = {|
  +priceMatch: ?{|
    +result: ?boolean
  |}
|};
export type PriceMatchMutation = {|
  variables: PriceMatchMutationVariables,
  response: PriceMatchMutationResponse,
|};
*/


/*
mutation PriceMatchMutation(
  $input: PriceMatchInput!
) {
  priceMatch(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PriceMatchPayload",
    "kind": "LinkedField",
    "name": "priceMatch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PriceMatchMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PriceMatchMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "852cc67faeb9b789666f40fd99000227",
    "id": null,
    "metadata": {},
    "name": "PriceMatchMutation",
    "operationKind": "mutation",
    "text": "mutation PriceMatchMutation(\n  $input: PriceMatchInput!\n) {\n  priceMatch(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '605d1c77041797deda8a244155cef159';

module.exports = node;
